__turbopack_context__.v({
  "active": "Switch-module__-eLXoa__active",
  "disabled": "Switch-module__-eLXoa__disabled",
  "root": "Switch-module__-eLXoa__root",
});
